import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiMenus extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "menus";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  get = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/menus/${this.data.id}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Requisição de menus",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  update = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Atualização de menus",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  list = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Requisição de menus",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  menus = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Requisição de menus",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiMenus;
